import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () =>
  'ticket_' + (Math.floor(Math.random() * 90000000) + 10000).toString() + '_ticket';

const initData = () => ({
  outputKey: keyAuto(),
  targetBoardId: null,
  ticketId: '',
});

const onLoadData = (rawData, component) => {
  const data = { ...initData(), ...rawData };
  if (!data.targetBoardId && component?.componentData?.targetBoardId) {
    data.targetBoardId = component.componentData.targetBoardId;
  }
  return data;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'get_board_ticket',
  endpoint: 'get_board_ticket',
  registryKey: 'get_board_ticket',
  initData,
  onLoadData,

  extraState: () => ({
    placeholders: [],
    position: null,
  }),

  extraActions: (set, get) => ({
    setKey: (value) => set((s) => ({ data: { ...s.data, outputKey: value } })),
    setTicketId: (ticketId) => set((s) => ({ data: { ...s.data, ticketId } })),
    setTargetBoardId: (targetBoardId) =>
      set((s) => ({ data: { ...s.data, targetBoardId } })),
    keyAuto,
  }),
});

export { createStore as createGetBoardTicketStore };
export const getGetBoardTicketStore = getStore;
export default defaultStore;
